import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { produce } from 'immer'

import { GetInstagramFeedResponse, InstagramPage } from '@3m5/sm_publish-frontend-api/models'

import { ApiError } from '../../store/postingRoot.reducer'

import { deleteInstagramPostComment, getIgPageFeed, getInstagramPage, writeIgPostComment } from './instagram.actions'

export interface InstagramState {
  fetching: boolean
  instagramPage?: InstagramPage
  instagramFeeds?: GetInstagramFeedResponse
  error: ApiError
}

const INITIAL_STATE: InstagramState = {
  fetching: false,
  error: {},
}

export const instagramReducer = reducerWithInitialState(INITIAL_STATE)
  /**
   * getInstagramPage
   */
  .case(getInstagramPage.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getInstagramPage
    })
  })

  .case(getInstagramPage.done, (state, { result }) => {
    return produce(state, draft => {
      draft.instagramPage = result
      draft.fetching = false
    })
  })

  .case(getInstagramPage.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getInstagramPage = (error as Response)
    })
  })

  /**
   * getIgPageFeedInitiated
   */
  .case(getIgPageFeed.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.getIgPageFeed
    })
  })

  .case(getIgPageFeed.done, (state, { result }) => {
    return produce(state, draft => {
      draft.instagramFeeds = result
      draft.fetching = false
    })
  })

  .case(getIgPageFeed.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.getIgPageFeed = (error as Response)
    })
  })

  /**
   * writeIgPostComment
   */
  .case(writeIgPostComment.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.writeIgPostComment
    })
  })

  .case(writeIgPostComment.done, (state, { result }) => {
    return produce(state, draft => {
      draft.fetching = false
    })
  })

  .case(writeIgPostComment.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.writeIgPostComment = (error as Response)
    })
  })

  /**
   * deleteInstagramPostComment
   */
  .case(deleteInstagramPostComment.started, state => {
    return produce(state, draft => {
      draft.fetching = true
      delete draft.error.deletePostComment
    })
  })

  .case(deleteInstagramPostComment.done, (state, { result }) => {
    return produce(state, draft => {
      draft.fetching = false
    })
  })

  .case(deleteInstagramPostComment.failed, (state, { error }) => {
    return produce(state, draft => {
      draft.fetching = false
      draft.error.deletePostComment = (error as Response)
    })
  })
